// A pencil cursor for the colouring page, drawn in whatever colour is
// currently selected — so you can see what you are about to put down before
// you put it down.
//
// Drawn on a canvas rather than shipped as an SVG cursor: SVG cursors are
// still unreliable in Safari, and a data: PNG works everywhere.
//
// 64px, which is large enough for a child to follow easily and still well
// inside the 128px ceiling above which browsers ignore a cursor entirely.
// Size fights precision, so the graphite point is drawn long and sharp rather
// than scaled up with the rest: the hotspot is that point, and it has to be
// obvious which pixel it means.

const SIZE = 64;
const cache = new Map();

function roundedBar(g, x, y, w, h, r) {
    g.beginPath();
    g.moveTo(x + r, y);
    g.lineTo(x + w - r, y);
    g.quadraticCurveTo(x + w, y, x + w, y + r);
    g.lineTo(x + w, y + h - r);
    g.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    g.lineTo(x + r, y + h);
    g.quadraticCurveTo(x, y + h, x, y + h - r);
    g.lineTo(x, y + r);
    g.quadraticCurveTo(x, y, x + r, y);
    g.closePath();
}

function draw(color) {
    const c = document.createElement('canvas');
    c.width = SIZE;
    c.height = SIZE;
    const g = c.getContext('2d');

    // Tilted so the point sits at the bottom-left, the way a right-handed
    // pencil cursor normally reads. The hotspot below is that point.
    g.translate(SIZE / 2, SIZE / 2);
    g.rotate(Math.PI / 4);
    g.translate(-SIZE / 2, -SIZE / 2);

    const x = 21;
    const top = 7;
    const bottom = 44;
    const w = 22;
    const tipY = bottom + 15;

    g.lineJoin = 'round';
    g.lineCap = 'round';

    const ink = (width) => {
        g.lineWidth = width;
        g.strokeStyle = '#2b1a12';
        g.stroke();
    };

    // Barrel in the chosen colour
    roundedBar(g, x, top, w, bottom - top, 5);
    g.fillStyle = color;
    g.fill();
    ink(3.5);

    // A soft highlight down one side so pale colours still read as a pencil
    g.beginPath();
    g.moveTo(x + 5, top + 9);
    g.lineTo(x + 5, bottom - 6);
    g.lineWidth = 3.5;
    g.strokeStyle = 'rgba(255,255,255,0.55)';
    g.stroke();

    // Metal band
    roundedBar(g, x, top, w, 9, 5);
    g.fillStyle = '#e2e2e2';
    g.fill();
    ink(3.5);

    // Wooden shoulder
    g.beginPath();
    g.moveTo(x - 0.5, bottom);
    g.lineTo(x + w + 0.5, bottom);
    g.lineTo(x + w / 2, tipY);
    g.closePath();
    g.fillStyle = '#f3cfa2';
    g.fill();
    ink(3.5);

    // Graphite point: deliberately long and narrow. A blunt wedge at this size
    // leaves you guessing which pixel the click lands on.
    g.beginPath();
    g.moveTo(x + w / 2 - 3, bottom + 6);
    g.lineTo(x + w / 2 + 3, bottom + 6);
    g.lineTo(x + w / 2, tipY);
    g.closePath();
    g.fillStyle = '#2b2b2b';
    g.fill();
    g.lineWidth = 1.2;
    g.strokeStyle = '#000';
    g.stroke();

    // A pale collar just behind the point, so the dark tip stays readable
    // against dark artwork as well as light.
    g.beginPath();
    g.moveTo(x + w / 2 - 4.6, bottom + 4.4);
    g.lineTo(x + w / 2 + 4.6, bottom + 4.4);
    g.lineWidth = 1.6;
    g.strokeStyle = 'rgba(255,255,255,0.9)';
    g.stroke();

    return c.toDataURL('image/png');
}

/**
 * CSS cursor value for a pencil in `color`. The hotspot is the graphite
 * point, so a click lands where the drawing shows it will.
 */
export default function pencilCursor(color) {
    if (!cache.has(color)) {
        try {
            cache.set(color, `url("${draw(color)}") 13 51, crosshair`);
        } catch (e) {
            cache.set(color, 'crosshair');
        }
    }
    return cache.get(color);
}
